<template>
  <div>
    <label
      class="mb-1 block text-left text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <BaseSelect
      v-model="value"
      :options="computedOptions"
      :has-error="hasError"
    />

    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script
  setup
  lang="ts"
  generic="TValue extends string | number | boolean"
>
import { useField } from "vee-validate"

import type { Option } from "@/composables/options/options"

type Props = {
  name: string
  options: Array<Option<TValue>>
  label?: string
  disableNull?: boolean
}

const props = defineProps<Props>()

const { value, errorMessage } = useField<TValue | null>(
  props.name,
  undefined,
  {
    initialValue: undefined,
  }
)

const hasError = computed(() => !!errorMessage.value)

const computedOptions = computed(() => [
  ...(props.disableNull
    ? []
    : [{ value: null, label: "---" }]),
  ...props.options,
])
</script>
